import { createStore as reduxCreateStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import totalPriceMiddleware from './totalPriceMiddleware';
import dateMiddleware from './dateMiddleware';
import paymentMethodMiddleware from './paymentMethodMiddleware';
import reduxMiddleware from './reduxMiddleware';
import guestTypesMiddleware from './guestTypesMiddleware';
import boardBasesMiddleware from './boardBasesMiddleware';
import currencyMiddleware from './currencyMiddleware';

import getReducers from './reducers';

export default function createStore(initialValues) {
	// všechny dispatch funkce teď vrací promise
	//const promiseMiddleware = store => next => action => Promise.resolve(next(action));

	const middleware = composeWithDevTools({
		maxAge: 5000,
	})(
		// nejprve thunk a potom promise, v action creatorech totiž chceme,
		// aby dispatchnutí akce vrátilo promisu
		applyMiddleware(
			thunk,
			currencyMiddleware,
			dateMiddleware,
			totalPriceMiddleware,
			paymentMethodMiddleware,
			guestTypesMiddleware,
			boardBasesMiddleware,
			reduxMiddleware,
		),
	);

	const reducers = getReducers(initialValues);

	return reduxCreateStore(reducers, {}, middleware);
}



// WEBPACK FOOTER //
// ./src/store/store.js